import { render, staticRenderFns } from "./CopmareRaceImageFooter.vue?vue&type=template&id=5f1efa86&scoped=true&"
import script from "./CopmareRaceImageFooter.vue?vue&type=script&lang=js&"
export * from "./CopmareRaceImageFooter.vue?vue&type=script&lang=js&"
import style0 from "./CopmareRaceImageFooter.vue?vue&type=style&index=0&id=5f1efa86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1efa86",
  null
  
)

export default component.exports